/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.51   Rana simulation core release: 3.7.3   deployed on:  10:12AM (UTC) on September 07, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * * `mean` - mean
 * * `max` -  maximum
 * * `min` -  minimum
 * @export
 */
export const AggregationMethodEnum = {
  MEAN: "mean",
  MAX: "max",
  MIN: "min",
} as const;
export type AggregationMethodEnum =
  (typeof AggregationMethodEnum)[keyof typeof AggregationMethodEnum];

export function instanceOfAggregationMethodEnum(value: any): boolean {
  for (const key in AggregationMethodEnum) {
    if (Object.prototype.hasOwnProperty.call(AggregationMethodEnum, key)) {
      if (AggregationMethodEnum[key as keyof typeof AggregationMethodEnum] === value) {
        return true;
      }
    }
  }
  return false;
}

export function AggregationMethodEnumFromJSON(json: any): AggregationMethodEnum {
  return AggregationMethodEnumFromJSONTyped(json, false);
}

export function AggregationMethodEnumFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): AggregationMethodEnum {
  return json as AggregationMethodEnum;
}

export function AggregationMethodEnumToJSON(value?: AggregationMethodEnum | null): any {
  return value as any;
}

export function AggregationMethodEnumToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean
): AggregationMethodEnum {
  return value as AggregationMethodEnum;
}
